import request from '@/utils/http';

// 主页列表数据
export const getSearchList = (data) => {
    return request({
        url: `/api-tms/algorithm/line/header/search`,
        method: 'post',
        data
    });
};
// 详情订单查询
export const getOrderList = (data) => {
    return request({
        url: `/api-tms/algorithm/line/order/search`,
        method: 'post',
        data
    });
};
// 详情车次查询
export const getLineList = (data) => {
    return request({
        url: `/api-tms/algorithm/line/detail/search`,
        method: 'post',
        data
    });
};
// 转移单查询接口
export const getTransferLineList = (data) => {
    return request({
        url: `/api-tms/algorithm/line/detail/transfer/search`,
        method: 'post',
        data
    });
};
// 车次作废
export const cancelTrainNum = (data) => {
    return request({
        url: `/api-tms/algorithm/line/detail/cancel`,
        method: 'post',
        data
    });
};
// 可视化调整查询
export const searchWithOrder = (data) => {
    return request({
        url: `/api-tms/algorithm/line/detail/searchWithOrder`,
        method: 'post',
        data
    });
};
// 预配载页面查询查询
export const getPreloadTableList = (data) => {
    return request({
        url: `/api-tms/algorithm/preloading/queryByPage`,
        method: 'post',
        data
    });
};
// 车次调整原因填写
export const adjustConfirmRecompute = (data) => {
    return request({
        url: `/api-tms/algorithm/line/detail/operate`,
        method: 'post',
        data
    });
};
// 一键排单
export const oneDispatch = (data) => {
    return request({
        url: `/api-tms/algorithm/one/click/dispatch`,
        method: 'post',
        data
    });
};
// 加单分组查询
export const queryGroup = (data) => {
    return request({
        url: `/api-tms/algorithm/preloading/queryGroup`,
        method: 'post',
        data
    });
};
// 地图排车加单获取分组
export const getNewSourceRoot = (params) => {
    return request({
        url: `/api-tms/transport/grouppolicy/list2`,
        method: 'post',
        data: params
    }).then(res => res);
};
// 地图排车获取分组详情
export const getNewSourceData = (params) => {
    return request({
        url: `/api-tms/transport/list/bygrouppolicy`,
        method: 'post',
        data: params
    }).then(res => res);
};
// 加单，查询tk单明细
export const queryByGroup = (data) => {
    return request({
        url: `/api-tms/algorithm/preloading/queryByGroup`,
        method: 'post',
        data
    });
};
// 排车
export const dispatchSave = (data) => {
    return request({
        url: `/api-tms/dispatch/algorithm/save/v2`,
        method: 'post',
        data
    });
};
// 整车排车时提示在途跟踪方式
export const promptTrackType = (data) => {
    return request({
        url: `/api-tms/dispatch/promptTrackType?dispatchNo=${data}`,
        method: 'post'
    });
};
// 车次获取里程
export const calculate = (data) => {
    return request({
        url: '/api-tms/algorithm/line/distance/calculate',
        method: 'post',
        data
    });
};
// 采纳
export const adoptApi = (data) => {
    return request({
        url: `/api-tms/algorithm/line/detail/adopt`,
        method: 'post',
        data
    });
};
// 设置服务平台配置
export const setSiteCodeList = (data) => {
    return request({
        url: `/api-tms/newDispatchTool/algorithm/operator/create`,
        method: 'post',
        data
    });
};
// 获取服务平台配置
export const getSiteCodeList = (data) => {
    return request({
        url: `/api-tms/newDispatchTool/algorithm/operator/queryLatest`,
        method: 'get',
        params: data
    });
};

// 加单
export const addApi = (data) => {
    return request({
        url: `/api-tms/algorithm/line/detail/order/add`,
        method: 'post',
        data
    });
};
// 减单
export const reduceApi = (data) => {
    return request({
        url: `/api-tms/algorithm/line/detail/order/reduce`,
        method: 'post',
        data
    });
};
// 转移
export const transferApi = (data) => {
    return request({
        url: `/api-tms/algorithm/line/detail/order/transfer`,
        method: 'post',
        data
    });
};
// 转移新建
export const transferNew = (data) => {
    return request({
        url: `/api-tms/algorithm/line/detail/order/transferNew`,
        method: 'post',
        data
    });
};
// 供应商保存,编辑
export const getDispathOrderPreservation = (data) => {
    return request({
        url: `/api-tms/dispatch/updateeditdispatchinfo`,
        method: 'put',
        data
    });
};

// 可视化调整转移
export const transferAdjustApi = (data) => {
    return request({
        url: `/api-tms/algorithm/line/detail/order/adjust`,
        method: 'post',
        data
    });
};
// 算法进度计算
export const check = (data) => {
    return request({
        url: `/api-tms/algorithm/result/check`,
        method: 'post',
        data
    });
};
// 装车排序
export const unissueCount = (data) => {
    return request({
        url: `/api-tms/dispatch/unissue/ztb/count`,
        method: 'post',
        data
    });
};
// 获取预设区域数据
export const getLayerIdListApi = (data) => {
    return request({
        url: `/api-tms/newDispatchTool/presupposeLayer/queryBySiteCode`,
        method: 'post',
        data
    });
};
// 白名单接口
export const getWhiteListApi = (params) => {
    return request({
        url: `/api-opms/opms/whitelist/list`,
        method: 'get',
        params
    });
};
// 获取仓库信息数据
export const getWarHouseList = (data) => {
    return request({
        url: `/api-tms/newDispatchTool/warehouse/queryBySiteCode`,
        method: 'post',
        data
    });
};

// 商超订单标记
export const sendSuperMarket = (data) => {
    return request({
        url: `/api-tms/newDispatchTool/supermarket/mark`,
        method: 'post',
        data
    });
};

// 算法预配载查询接口
export const getMustDispatch = (data) => {
    return request({
        url: `/api-tms/algorithm/mustDispatch/query`,
        method: 'post',
        data
    });
};
// 跨车次调整数据查询接口
export const algorithmStatistic = (data) => {
    return request({
        method: 'post',
        url: `/api-tms/algorithm/line/detail/statistic`,
        data
    });
};
// 服务平台白名单
export const getSiteCodeWhiteListApi = (data) => {
    return request({
        url: '/api-tms/algorithm/siteCode/disable',
        method: 'post',
        data
    });
};
// 不走高速服务平台白名单
export const getAvoidHighwaySiteCodeApi = (data) => {
    return request({
        url: '/api-tms/algorithm/nonHighwaySites/query',
        method: 'post',
        data
    });
};
